module.exports = __webpack_public_path__ + "static/media/track-bed-bg@sm.f4024241.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/awair/track-bed-bg@sm.jpg
// module id = 247
// module chunks = 0